module.exports = __webpack_public_path__ + "resources/img/img-secuve-tos-02-m-jp.824b31e381212044a1ced10af42e92ff.png";